import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  DestroyRef,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AccordionService } from '../accordion.service';
import { SdAccordionLabelComponent } from './accordion-label';

let nextId = 0;

@Component({
  selector: 'sd-accordion-item',
  imports: [CommonModule],
  styleUrls: ['./accordion-item.component.scss'],
  templateUrl: './accordion-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdAccordionItemComponent implements OnInit, AfterContentInit {
  @ContentChild(SdAccordionLabelComponent) label?: SdAccordionLabelComponent;

  @Input() set id(id: string) {
    this._id = id;
  }

  isOpened = signal(false);

  private _id = `sd-accordion-${++nextId}`;

  constructor(
    private accordionService: AccordionService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.accordionService
      .watch(this._id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((_isOpened) => {
        this.isOpened.set(_isOpened);
        this.updateLabel(_isOpened);
      });
  }

  ngAfterContentInit(): void {
    if (this.label) {
      this.label.clicked.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.accordionService.toggle(this._id);
        this.updateLabel(this.isOpened());
      });
    }
  }

  private updateLabel(opened: boolean): void {
    if (this.label) {
      this.label.opened.set(opened);
    }
  }
}
